import React, { useRef, useState } from "react";
import {
  Loader,
  Dimmer,
  TableBody,
  TableCell,
  TableRow,
} from "semantic-ui-react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { formatMoneda, round, validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import moment from "moment";
import useTableScroll from "../useTableScroll";
import { ProcesosMontos } from "./modalAgreProcesosMontos";
import CatalogoValorMonedas from "../../catalogos/catalogoValorMoneda";
//import TablaRetencionesporCobrar from "./tablaRetencionesxCobrar";

export const RegistrarPago = (props) => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const ncaja = JSON.parse(sessionStorage.getItem("numcaja"));

  const headCells = [
    { label: "FORMA DE PAGO", textAlign: "center" },
    { label: "REFERENCIA", textAlign: "center" },
    { label: "MONTO", textAlign: "center" },
    { label: "MONTO AL CAMBIO", textAlign: "center" },
    { label: "", textAlign: "center" },
  ];

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtFechaPago = useRef();

  const [restabs, setRestabs] = useState(0.0);
  const [anticipos, setAnticipos] = useState(0.0);
  const [sobrabs, setSobrabs] = useState(0.0);
  const [totalresta, setTotalresta] = useState(0.0);
  const [totalsobra, setTotalsobra] = useState(0.0);
  const [totaldolares, setTotaldolares] = useState(0.0);
  const [totalcredito, setTotalcredito] = useState(0.0);
  const [totales, setTotales] = useState(0.0);
  const [totalesr, setTotalesr] = useState(0.0);
  const [totalesrb, setTotalesrb] = useState(0.0);
  const [totaldeuda, setTotaldeuda] = useState(0.0);
  const [totaldeudabs, setTotaldeudabs] = useState(0.0);
  const [tasa, setTasa] = useState(0.0);
  const [mostrar1, setMostrar1] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [numfactu, setNumfactu] = useState("");
  const [idvendedor, setIdvendedor] = useState(0);
  const [idfactu, setIdfactu] = useState(0);
  const [body, setBody] = useState(null);
  const [idmon, setIdmon] = useState(null);
  const [retencionesid, setRetencionesid] = useState([]);
  const [activate, setActivate] = useState(false);
  const [idmone, setIdmone] = useState(0);
  const [valormone, setValormone] = useState(0.0);
  const [tiponot, setTiponot] = useState("");
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [combomoneda, setComboMoneda] = useState([]);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false,
  });

  const { TblContainer, TblHead } = useTableScroll(headCells, filterFn);

  const blanquear = () => {
    setActivate(false);
    setRestabs(0.0);
    setSobrabs(0.0);
    setAnticipos(0.0);
    setIdfactu(0);
    setIdvendedor(0);
    setNumfactu("");
    setIdmon(null);
    setRetencionesid([]);
    setTotalresta(0.0);
    setTotales(0.0);
    setTotalesr(0.0);
    setTotalesrb(0.0);
    setMostrar2(false);
    setTotaldolares(0.0);
    setTotalsobra(0.0);
    setTotaldeuda(0.0);
    setRecords([]);
    setValormone(0.0);
    setIdmone(0);
    setTiponot("");
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
    props.onRenderizar();
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1 || props.ope === 2) {
      if (records.length > 0) {
        sigue = true;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el Pago !",
          icono: "informacion",
        });
        sigue = false;
      }

      if (sigue) {
        let pago = [];
        let pagodetalle = [];

        pago.push({
          idpago: 0,
          numpago: "",
          concepto:
            props.tipo === "notaentrega"
              ? "PAGO DE NOTA DE ENTREGA N°" + " " + props.numfactu
              : props.tipo === "debito"
                ? "PAGO DE NOTA DE DEBITO N°" + " " + props.numfactu
                : "PAGO DE FACTURA N°" + " " + props.numfactu,
          idcliente: props.idclient,
          idvendedor: idvendedor,
          idfactura: idfactu,
          monto: totaldolares + totalesr,
          descuento: 0.00,
          iva: props.iva,
          montoiva: props.montoiva,
          abono: 0.00,
          total: totaldolares + totalesr,
          sobrante: parseFloat(totalsobra),
          fecharegistro: txtFechaPago.current.value,
          tipofac:
            props.tipo === "notaentrega"
              ? "NE"
              : props.tipo === "debito"
                ? "ND"
                : "FA",
          numfactura: numfactu,
          status:
            formatMoneda(
              totaldolares.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            ) ===
              formatMoneda(
                totaldeuda.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              )
              ? 1
              : 0,
          idmoneda: idmone,
          valormoneda: valormone,
          montodeuda: totaldeuda,
        });

        for (let i = 0; i < records.length; i++) {

          pagodetalle.push({
            idpago: 0,
            monto: records[i].tipo === 7 || records[i].tipo === 8 || records[i].tipo === 9 || records[i].tipo === 10 ? records[i].montodefinic : records[i].montos,
            nroreferencia: records[i].referencia,
            idmoneda: records[i].tipodivisa,
            numcredito: records[i].notacredito,
            factorcambio: records[i].valormoneda,
            moneda:
              records[i].simbolo === "$"
                ? "DOLAR"
                : records[i].simbolo === "€"
                  ? "EURO"
                  : "BOLIVARES",
            tipo: records[i].tipo,
            fechaemision: records[i].fechapago,
            idcuenta: records[i].idbanco,
            ...(records[i].tipo === 10 && {
              idretiene: 0,
              porc_unidad: records[i].porc,
              idretencion: records[i].tiporeten,
              idusuario: idvendedor,
              numorden: numfactu
            }),
            idreten: records[i].tiporeten
          });

        }
        setBody({
          notaentre: props.notentraga,
          notaentredet: props.notaentregadeta,
          pagos: pago,
          pagosdeta: pagodetalle,
          app: false,
          ncaja: ncaja,
          fecharev: null,
          fechapag: null,
          nidcaja: null,
          idusu: null,
          motivo: '',
          opinv: props.opinvc,
          opeinvdet: props.opeinvdetc
        });

        let msg = "";
        if (props.ope === 1 || props.ope === 2) {
          msg = "Esta Seguro de Registrar este Pago.";
        }

        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      }
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let operacion;
    if (props.notentraga[0].idnotaentrega > 0) {
      operacion = props.ope;
    } else {
      operacion = 1;
    }

    let endpoint = `${op.conexion}/api/inventario/actualizarpostventas/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.ope === 1 || props.ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Pago Registrado Correctamente",
              icono: "exito",
            });

            if (props.tipo === "notaentrega") {
              if (sessionStorage.getItem("bluetooth") === "true") {
                props.ticketBluetooth(response.data.idnotaent);
              } else {
                imprimirFactura(response.data.idnotaent);
              }
            } else {
              imprimirFactura(response.data.idnotaent);

            }

          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancelar();
    props.onRenderizar();
  };

  const imprimirFactura = (factu) => {

    let endpoint = `http://localhost:9000/imprimir?idfactura=${"'" + factu + "'"}&logo1=logo1.png`;

    axios
      .get(endpoint)
      .then(function (response) {
        setActivate(false);
      }).finally(() => {
        setActivate(false);
      });
  };

  const seleccionarReten = (numorden) => {
    let campos = "idretencion";
    let nomtab = "retiene";
    let nomid = "numorden";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${numorden}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRetencionesid(response.data);
          } else {
            setRetencionesid([]);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMonedas = (fecha) => {

    let endpoint = `${op.conexion}/api/moneda/selectmonedas?fecha=${fecha}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idmoneda > 0) {
            setComboMoneda(response.data);
            setIdmon(response.data.idmoneda);

            let valormoney = response.data.valor;
            let total = 0.0;
            let idmone = response.data.idmoneda;

            setTasa(valormoney);
            setValormone(valormoney);
            setIdmone(idmone);

            let datos = [...records];
            let montototal = 0.0;
            let restbs = 0.0;
            let data = [];
            let predeterminada;
            let montod = totaldeuda;
            let calcular = 0.0;
            let sobrante = 0.0;
            let totalm = 0.0;
            let tosobrabs = 0.0;
            let calcularbs = 0.0;
            let montbs = 0.0;
            let montrestabs = 0.0;
            let restabss = 0.0;
            let reten = 0.0;
            let tore = 0.0;

            restbs = totaldeuda > 0 ? round(totaldeuda, 2) * response.data.valor : props.monto * response.data.valor;
            predeterminada = response.data.valor;

            if (datos.length > 0) {
              for (let e = 0; e < datos.length; e++) {
                data.push({
                  forma:
                    datos[e].tipo === 1
                      ? "Efectivo Bs"
                      : datos[e].tipo === 2
                        ? "Tarjeta(Debito) Bs"
                        : datos[e].tipo === 3
                          ? "Tarjeta(Crédito) Bs"
                          : datos[e].tipo === 4
                            ? "Pago Movil Bs"
                            : datos[e].tipo === 5
                              ? "Deposito Bancario Bs"
                              : datos[e].tipo === 6
                                ? "Transferencia Bancaria Bs"
                                : datos[e].tipo === 7
                                  ? "Divisa" + " " + datos[e].simbolo
                                  : datos[e].tipo === 8
                                    ? "Saldo a Credito $"
                                    : datos[e].tipo === 9 ? "Saldo Anticipo $" : datos[e].forma,
                  montos: datos[e].montos,
                  index: datos[e].index,
                  fechapago: datos[e].fechapago,
                  tipo: datos[e].tipo,
                  tipodivisa: datos[e].tipodivisa,
                  montoalcambio:
                    datos[e].tipo === 8 ||
                      datos[e].tipo === 9 ||
                      datos[e].tipo === 10 ||
                      (datos[e].tipo === 7 && datos[e].tipodivisa === idmon)
                      ? datos[e].montos * response.data.valor
                      : datos[e].montoalcambio,
                  montodefinic:
                    datos[e].tipo === 7 && datos[e].tipodivisa !== idmon
                      ? datos[e].montoalcambio / response.data.valor
                      : datos[e].tipo === 8 ||
                        datos[e].tipo === 9 ||
                        datos[e].tipo === 10 ||
                        (datos[e].tipo === 7 && datos[e].tipodivisa === idmon)
                        ? (datos[e].montodefinic * response.data.valor) / response.data.valor
                        : datos[e].montoalcambio / response.data.valor,
                  notacredito:
                    datos[e].tipo === 8 || datos[e].tipo === 9
                      ? datos[e].notacredito
                      : "",
                  valormoneda:
                    datos[e].tipo === 7 && datos[e].tipodivisa !== idmon
                      ? datos[e].valormoneda
                      : datos[e].tipo === 8 ||
                        datos[e].tipo === 9 ||
                        datos[e].tipo === 10 ||
                        (datos[e].tipo === 7 && datos[e].tipodivisa === idmon)
                        ? response.data.valor
                        : datos[e].valormoneda,
                  idbanco: datos[e].idbanco,
                  referencia: datos[e].referencia,
                  simbolo: datos[e].simbolo,
                });
              }

              for (let i = 0; i < data.length; i++) {

                if (data[i].tipo === 10) {
                  reten = parseFloat(reten) + parseFloat(data[i].montodefinic);
                } else {
                  montototal = parseFloat(montototal) + parseFloat(data[i].montodefinic);
                }

              }

              total = round(montod, 2) - round(montototal, 2) - round(reten, 2);
              calcular = round(montototal, 2) > round(montod, 2) ? "0,00" : total;
              sobrante = round(montototal + reten, 2) > round(montod, 2) ? Math.abs(total) : "0,00";
              totalm = montototal * predeterminada;
              tore = reten * predeterminada;
              tosobrabs = sobrante * predeterminada;

              montbs = round(montod, 2) * predeterminada;
              montrestabs = round(montod, 2) * predeterminada - totalm - tore;
              restabss = round(montototal, 2) * predeterminada;
              calcularbs = restabss > montbs ? "0,00" : montrestabs;

              setSobrabs(Math.abs(tosobrabs));
              setRestabs(Math.abs(calcularbs));
              setTotalresta(Math.abs(calcular));
              setTotalsobra(sobrante);
              setTotaldolares(montototal);
              setTotalesr(reten);
              setTotalesrb(tore);
              setTotales(totalm);
            } else {
              setRestabs(Math.abs(restbs));
            }
            setRecords(data);
            /* if (totaldeuda <= 0) {
              setTotaldeuda(props.monto);
            } */
            setTotaldeudabs(restbs);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const handleAceptaDatos = (values) => {
    setMostrar1(false);

    let predeterminada;
    let totalm = 0.0;
    let idmoney;
    let valormoney = 0.0;
    let indx = 0;
    let credito = 0.0;
    let credit = 0.0;

    let datos = [...records];
    let montod = totaldeuda;
    let montototal = 0.0;
    let total = 0.0;
    let calcular = 0.0;
    let sobrante = 0.0;
    let reten = 0.0;
    let tore = 0.0;

    for (let b = 0; b < datos.length; b++) {
      if (datos[b].index > 0) {
        indx = datos[b].index + 1;
      } else {
        indx = indx + 1;
      }
    }

    for (let i = 0; i < values.length; i++) {
      idmoney = values[i].tipodivisa;

      predeterminada = tasa;

      datos.push({
        forma:
          values[i].formapago === 1
            ? "Efectivo Bs"
            : values[i].formapago === 2
              ? "Tarjeta(Debito) Bs"
              : values[i].formapago === 3
                ? "Tarjeta(Crédito) Bs"
                : values[i].formapago === 4
                  ? "Pago Movil Bs"
                  : values[i].formapago === 5
                    ? "Deposito Bancario Bs"
                    : values[i].formapago === 6
                      ? "Transferencia Bancaria Bs"
                      : values[i].formapago === 7
                        ? "Divisa" + " " + values[i].simbolo
                        : values[i].formapago === 8
                          ? "Saldo a Credito $"
                          : "Saldo Anticipo $",
        montos: values[i].monto,
        fechapago: values[i].fecha,
        tipo: values[i].formapago,
        tipodivisa: values[i].tipodivisa,
        montoalcambio:
          values[i].formapago === 7 && values[i].tipodivisa === idmon
            ? values[i].monto * predeterminada
            : values[i].formapago === 7 && values[i].tipodivisa !== idmon
              ? values[i].monto * valormoney
              : values[i].formapago === 8 || values[i].formapago === 9
                ? values[i].monto * predeterminada
                : values[i].monto,
        montodefinic:
          values[i].formapago === 7 && values[i].tipodivisa === idmon
            ? (values[i].monto * predeterminada) / predeterminada
            : values[i].formapago === 7 && values[i].tipodivisa !== idmon
              ? (values[i].monto * valormoney) / predeterminada
              : values[i].formapago === 8 || values[i].formapago === 9
                ? values[i].monto
                : values[i].monto / predeterminada,
        index: indx,
        notacredito:
          values[i].formapago === 8 || values[i].formapago === 9
            ? values[i].notacredito
            : "",
        valormoneda:
          values[i].formapago === 7 && values[i].tipodivisa !== idmon
            ? values[i].valormoneda
            : values[i].formapago === 8 ||
              values[i].formapago === 9 ||
              (values[i].formapago === 7 && values[i].tipodivisa === idmon)
              ? predeterminada
              : values[i].valormoneda,
        idbanco: values[i].idbanco,
        referencia: values[i].referencia,
        simbolo: values[i].simbolo,
        tiporeten: values[i].codigo,
        porc: values[i].porc > 0 ? values[i].porc : ""
      });
    }

    for (let e = 0; e < datos.length; e++) {

      if (datos[e].tipo === 10) {
        reten = parseFloat(reten) + parseFloat(datos[e].montodefinic);
      } else {
        montototal = parseFloat(montototal) + parseFloat(datos[e].montodefinic);
      }

      if (datos[e].tipo === 8 || datos[e].tipo === 9) {
        credito = parseFloat(datos[e].montodefinic);
      } else {
        credito = totalcredito;
      }
    }

    let totalcredit = 0.0;

    if (values[0].formapago === 8) {
      credit = parseFloat(totalcredito) - credito;
    } else {
      credit = totalcredito;
    }

    if (values[0].formapago === 9) {
      credit = parseFloat(anticipos) - credito;
    } else {
      credit = anticipos;
    }

    let tosobrabs = 0.0;
    let totalanticipo = 0.0;
    let calcularbs = 0.0;
    let montbs = 0.0;
    let montrestabs = 0.0;
    let restabss = 0.0;

    totalcredit =
      values[0].formapago === 8
        ? credit >= parseFloat(totalcredito)
          ? "0,00"
          : credit
        : totalcredito;
    totalanticipo =
      values[0].formapago === 9
        ? credit >= parseFloat(anticipos)
          ? "0,00"
          : credit
        : anticipos;
    total = round(montod, 2) - round(montototal, 2) - round(reten, 2);
    calcular = round(montototal, 2) > round(montod, 2) ? "0,00" : total;
    sobrante = round(montototal + reten, 2) > round(montod, 2) ? Math.abs(total) : "0,00";
    totalm = montototal * predeterminada;
    tore = reten * predeterminada;
    tosobrabs = sobrante * predeterminada;

    montbs = round(montod, 2) * predeterminada;
    montrestabs = round(montod, 2) * predeterminada - totalm - tore;
    restabss = round(montototal, 2) * predeterminada;
    calcularbs = restabss > montbs ? "0,00" : montrestabs;

    setAnticipos(totalanticipo);
    setSobrabs(Math.abs(tosobrabs));
    setRestabs(Math.abs(calcularbs));
    setTotalcredito(totalcredit);
    setTotalresta(Math.abs(calcular));
    setTotalsobra(sobrante);
    setTotaldolares(montototal);
    setTotales(totalm);
    setRecords(datos);
  };

  const handleAceptaDatosReten = (values) => {
    setMostrar3(false);

    let predeterminada;
    let totalm = 0.0;
    let idmoney;
    let indx2 = 0;
    let indx = 0;
    let tore = 0.0;
    let reten = 0.0;

    let datos = [...records];
    let montod = totaldeuda;
    let montototal = 0.0;
    let total = 0.0;
    let calcular = 0.0;
    let sobrante = 0.0;

    if (retencionesid.length > 0) {
      for (let c = 0; c < retencionesid.length; c++) {
        if (parseInt(retencionesid[c].idretencion) === parseInt(values[0].codigo)) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Este Tipo de Retención ya fue Procesada !",
            icono: "informacion",
          });
          return;
        }
      }
    } else {
      for (let b = 0; b < datos.length; b++) {

        if (parseInt(datos[b].tiporeten) === parseInt(values[0].codigo)) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Este Tipo de Retención ya fue Procesada !",
            icono: "informacion",
          });
          return;
        }

        indx = indx;
      }
    }


    for (let i = 0; i < values.length; i++) {

      idmoney = idmon;

      predeterminada = tasa;

      indx === 0 ? indx2 = indx2 + 1 : indx + 1;

      datos.push({
        forma: values[i].descripcion,
        montos: values[i].monto,
        fechapago: values[i].fecha,
        tipo: values[i].formapago,
        tipodivisa: idmoney,
        montoalcambio: values[i].monto * predeterminada,
        montodefinic: values[i].monto,
        index: indx2,
        notacredito: "",
        valormoneda: predeterminada,
        idbanco: values[i].idbanco,
        referencia: values[i].referencia,
        simbolo: values[i].simbolo,
        tiporeten: values[i].codigo,
        porc: values[i].porc
      });
    }

    for (let e = 0; e < datos.length; e++) {

      if (datos[e].tipo === 10) {
        reten = parseFloat(reten) + parseFloat(datos[e].montodefinic);
      } else {
        montototal = parseFloat(montototal) + parseFloat(datos[e].montodefinic);
      }

    }

    let tosobrabs = 0.0;
    let totalanticipo = 0.0;
    let calcularbs = 0.0;
    let montbs = 0.0;
    let montrestabs = 0.0;
    let restabss = 0.0;

    total = round(montod, 2) - round(montototal, 2) - round(reten, 2);
    calcular = round(montototal, 2) > round(montod, 2) ? "0,00" : total;
    sobrante = round(montototal + reten, 2) > round(montod, 2) ? Math.abs(total) : "0,00";
    totalm = montototal * predeterminada;
    tore = reten * predeterminada;
    tosobrabs = sobrante * predeterminada;

    montbs = round(montod, 2) * predeterminada;
    montrestabs = round(montod, 2) * predeterminada - totalm - tore;
    restabss = round(montototal, 2) * predeterminada;
    calcularbs = restabss > montbs ? "0,00" : montrestabs;

    setAnticipos(totalanticipo);
    setSobrabs(Math.abs(tosobrabs));
    setRestabs(Math.abs(calcularbs));
    setTotalresta(Math.abs(calcular));
    setTotalsobra(sobrante);
    setTotaldolares(montototal);
    setTotales(totalm);
    setTotalesr(reten);
    setTotalesrb(tore);
    setRecords(datos);
  }

  const calcularTotales = (data, datos) => {
    let predeterminada;
    let montod = totaldeuda;
    let montototal = 0.0;
    let total = 0.0;
    let calcular = 0.0;
    let sobrante = 0.0;
    let totalm = 0.0;
    let credito = 0.0;
    let credit = 0.0;
    let ant = 0.0;
    let mant = 0.0;
    let tore = 0.0;
    let reten = 0.0;
    let tocredict = totalcredito;
    let totalanticipo = anticipos;

    predeterminada = tasa;

    for (let e = 0; e < data.length; e++) {

      for (let c = 0; c < datos.length; c++) {

        if (datos[c].tipo === 10) {
          reten = parseFloat(reten) + parseFloat(datos[c].montodefinic);
        } else {
          montototal = parseFloat(montototal) + parseFloat(datos[c].montodefinic);
        }

      }

      if (data[e].tipo === 8) {
        credito = parseFloat(data[e].montodefinic);
        credit = parseFloat(tocredict) + credito;
      } else {
        credito = tocredict;
        credit = tocredict;
      }

      if (data[e].tipo === 9) {
        ant = parseFloat(data[e].montodefinic);
        mant = parseFloat(totalanticipo) + ant;
      } else {
        ant = totalanticipo;
        mant = totalanticipo;
      }

    }

    let totalcredit = 0.0;
    let restabs = 0.0;
    let tosobrabs = 0.0;
    let toanticipo = 0.0;

    totalcredit = credit;
    toanticipo = mant;

    total = round(montod, 2) - round(montototal, 2) - round(reten, 2);
    calcular = montototal > round(montod, 2) ? "0,00" : total;
    sobrante = montototal > round(montod, 2) ? total : "0,00";
    totalm = round(montototal, 2) * predeterminada;
    tore = round(reten, 2) * predeterminada;

    restabs = calcular * predeterminada;
    tosobrabs = sobrante * predeterminada;

    setAnticipos(toanticipo);
    setSobrabs(Math.abs(tosobrabs));
    setRestabs(Math.abs(restabs));
    setTotalcredito(totalcredit);
    setTotalresta(Math.abs(calcular));
    setTotalsobra(sobrante);
    setTotalesr(reten);
    setTotalesrb(tore);
    setTotaldolares(montototal);
    setTotales(totalm);
  };

  const handleAceptaValorMoneda = (values) => {
    setMostrar2(false);

    setTasa(values.valor);
    setValormone(values.valor);
    setIdmone(values.idmoneda);

    let datos = [...records];
    let montototal = 0.0;
    let restbs = 0.0;
    let data = [];
    let predeterminada;
    let montod = totaldeuda;
    let total = 0.0;
    let calcular = 0.0;
    let sobrante = 0.0;
    let totalm = 0.0;
    let tosobrabs = 0.0;
    let calcularbs = 0.0;
    let montbs = 0.0;
    let montrestabs = 0.0;
    let restabss = 0.0;
    let reten = 0.0;
    let tore = 0.0;

    restbs = round(totaldeuda, 2) * values.valor;
    predeterminada = values.valor;

    if (datos.length > 0) {
      for (let e = 0; e < datos.length; e++) {
        data.push({
          forma:
            datos[e].tipo === 1
              ? "Efectivo Bs"
              : datos[e].tipo === 2
                ? "Tarjeta(Debito) Bs"
                : datos[e].tipo === 3
                  ? "Tarjeta(Crédito) Bs"
                  : datos[e].tipo === 4
                    ? "Pago Movil Bs"
                    : datos[e].tipo === 5
                      ? "Deposito Bancario Bs"
                      : datos[e].tipo === 6
                        ? "Transferencia Bancaria Bs"
                        : datos[e].tipo === 7
                          ? "Divisa" + " " + datos[e].simbolo
                          : datos[e].tipo === 8
                            ? "Saldo a Credito $"
                            : datos[e].tipo === 9 ? "Saldo Anticipo $" : datos[e].forma,
          montos: datos[e].montos,
          index: datos[e].index,
          fechapago: datos[e].fechapago,
          tipo: datos[e].tipo,
          tipodivisa: datos[e].tipodivisa,
          montoalcambio:
            datos[e].tipo === 8 ||
              datos[e].tipo === 9 ||
              datos[e].tipo === 10 ||
              (datos[e].tipo === 7 && datos[e].tipodivisa === idmon)
              ? datos[e].montos * values.valor
              : datos[e].montoalcambio,
          montodefinic:
            datos[e].tipo === 7 && datos[e].tipodivisa !== idmon
              ? datos[e].montoalcambio / values.valor
              : datos[e].tipo === 8 ||
                datos[e].tipo === 9 ||
                datos[e].tipo === 10 ||
                (datos[e].tipo === 7 && datos[e].tipodivisa === idmon)
                ? (datos[e].montodefinic * values.valor) / values.valor
                : datos[e].montoalcambio / values.valor,
          notacredito:
            datos[e].tipo === 8 || datos[e].tipo === 9
              ? datos[e].notacredito
              : "",
          valormoneda:
            datos[e].tipo === 7 && datos[e].tipodivisa !== idmon
              ? datos[e].valormoneda
              : datos[e].tipo === 8 ||
                datos[e].tipo === 9 ||
                datos[e].tipo === 10 ||
                (datos[e].tipo === 7 && datos[e].tipodivisa === idmon)
                ? values.valor
                : datos[e].valormoneda,
          idbanco: datos[e].idbanco,
          referencia: datos[e].referencia,
          simbolo: datos[e].simbolo,
        });
      }

      for (let i = 0; i < data.length; i++) {

        if (data[i].tipo === 10) {
          reten = parseFloat(reten) + parseFloat(data[i].montodefinic);
        } else {
          montototal = parseFloat(montototal) + parseFloat(data[i].montodefinic);
        }

      }

      total = round(montod, 2) - round(montototal, 2) - round(reten, 2);
      calcular = round(montototal, 2) > round(montod, 2) ? "0,00" : total;
      sobrante = round(montototal + reten, 2) > round(montod, 2) ? Math.abs(total) : "0,00";
      totalm = montototal * predeterminada;
      tore = reten * predeterminada;
      tosobrabs = sobrante * predeterminada;

      montbs = round(montod, 2) * predeterminada;
      montrestabs = round(montod, 2) * predeterminada - totalm - tore;
      restabss = round(montototal, 2) * predeterminada;
      calcularbs = restabss > montbs ? "0,00" : montrestabs;

      setSobrabs(Math.abs(tosobrabs));
      setRestabs(Math.abs(calcularbs));
      setTotalresta(Math.abs(calcular));
      setTotalsobra(sobrante);
      setTotaldolares(montototal);
      setTotalesr(reten);
      setTotalesrb(tore);
      setTotales(totalm);
    } else {
      setRestabs(Math.abs(restbs));
    }

    setRecords(data);
    setTotaldeudabs(restbs);
  };

  const eliminarFila = (values) => (e) => {
    e.preventDefault();
    var data = [...records];
    var elementos = [];
    var eliminado = [];

    for (let i = 0; i < data.length; i++) {
      if (values !== data[i].index) {
        elementos.push(data[i]);
      }

      if (values === data[i].index) {
        eliminado.push(data[i]);
      }
    }

    setRecords(elementos);
    calcularTotales(eliminado, elementos);
  };

  const onGestionar = (op) => (e) => {
    if (op === 1) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 2) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 3) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 4) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 5) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 6) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 7) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 8) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 9) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 10) {
      setOperacion(op);
      setMostrar3(true);
    }
  };

  const seleccionarCredito = (id) => {
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/seleccionarcredito?idcliente=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let montototal = 0.0;

            for (let i = 0; i < response.data.length; i++) {
              montototal =
                parseFloat(montototal) +
                parseFloat(response.data[i].totalmonto);
            }

            setTotalcredito(montototal);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChange = (e) => {
    if (e.target.name === 'fecha') {
      seleccionarMonedas(e.target.value);
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.ope === 1 || props.ope === 2) {
          setIdvendedor(props.idvendedor);
          setIdfactu(null);
          setNumfactu(props.numfactu);
          setTotaldeuda(props.monto);
          setTotalresta(props.monto);
          seleccionarCredito(props.idclient);
          setAnticipos(0.00);
          txtFechaPago.current.value =
            moment(fechasistema).format("YYYY-MM-DD");
          if (props.tipo === "notaentrega") {
            setTiponot("NE");
          } else {
            setTiponot("ND");
          }

          let fech = moment(fechasistema).format('YYYY-MM-DD');
          seleccionarMonedas(fech);

        } else {
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold" style={{ color: "#fff" }}>
          <h3>
            {props.tipo === "debito"
              ? "Registrar Pago - (Nota de Debito)"
              : props.tipo === "notaentrega"
                ? "Registrar Pago - (Nota de Entrega)"
                : "Registrar Pago - (Factura)"}
          </h3>
        </div>

        <a
          href="#"
          ref={btnSalir}
          disabled={botones.salir}
          onClick={cancelar}
          className="text-light"
        >
          <i className="fas fa-times fa-1x shadow"> {/* Salir */}</i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className="col-md-12 row mx-auto px-0">
          <div className="row col-md-12 rounded mx-auto">
            <fieldset
              className="row col-sm-12 mx-auto border-azul rounded mb-1"
              style={{ fontSizeAdjust: "0.6" }}
            >
              <legend className="float-none m-0 w-auto fs-4 fw-bold">
                Datos
              </legend>

              <div className="col-md-4 col-sm-12 row m-0 px-0">
                <div className="col-pd-280 px-1 py-2 mb-2">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA DE PAGO:
                    </label>
                    <input
                      type="date"
                      ref={txtFechaPago}
                      disabled={props.ope === 0 ? true : false}
                      name="fecha"
                      onChange={onChange}
                      className="form-control fs-6 text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>

              <div
                className="col-md-8 col-sm-12 row m-0 px-0 border-azul d-flex align-items-center"
                style={{ background: "#cfe2ff", borderRadius: "3px" }}
              >
                <div
                  className="col-5 px-1 row m-0"
                  style={{ fontSizeAdjust: "0.5" }}
                >
                  <label className="col-pd-130 px-1 text-left fs-5">
                    Total a Pagar:{" "}
                  </label>
                  <span className="col px-0 fw-bold text-right fs-5">
                    &nbsp;
                    {formatMoneda(
                      totaldeuda.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                    &nbsp;$
                  </span>
                </div>

                <div
                  className="col-6 px-1 row m-0 ml-auto"
                  style={{ fontSizeAdjust: "0.5" }}
                >
                  <label className="col-pd-180 px-1 text-left fs-5">
                    Total a Pagar Bs:{" "}
                  </label>
                  <span className="col px-0 fw-bold text-right fs-5">
                    &nbsp;
                    {formatMoneda(
                      totaldeudabs
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </span>
                </div>

                {/* <div className="px-0">
                  <hr className="m-0 w-100" />
                </div> */}

                {/* <div
                  className="col-7 px-1 row m-0 ml-auto border-azul"
                  style={{ fontSizeAdjust: "0.5" }}
                >
                  <label className="col-pd-190 px-1 text-left fs-5">
                    Restante a Pagar Bs:{" "}
                  </label>
                  <span className="col px-0 fw-bold text-right fs-5">
                    &nbsp;
                    {formatMoneda(
                      restabs.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                    &nbsp;
                  </span>
                </div> */}
              </div>

              <div
                className="col-md-4 col-sm-12 row m-0 px-0 d-flex justify-content-center border-azul py-2"
                style={{ background: "#cfe2ff", borderRadius: "3px" }}
              >
                <div className="col-6 mb-2 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    /* disabled={habilitado} */ style={{
                      height: "80px",
                      fontSize: "14px",
                    }}
                    onClick={onGestionar(1)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fas fa-money-bill-alt fs-5 mr-2"></i> Efectivo
                    Bs
                  </button>
                </div>
                <div className="col-6 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    /* disabled={habilitado} */ style={{
                      height: "80px",
                      fontSize: "14px",
                    }}
                    onClick={onGestionar(7)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fas fa-dollar-sign fs-5 mr-2"></i> Divisas
                  </button>
                </div>
                <div className="col-6 mb-2 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    /* disabled={habilitado} */ style={{
                      height: "80px",
                      fontSize: "14px",
                    }}
                    onClick={onGestionar(2)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fas fa-credit-card fs-5 mr-2"></i> Tarjeta de
                    Debito
                  </button>
                </div>
                <div className="col-6 mb-2 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    /* disabled={habilitado} */ style={{
                      height: "80px",
                      fontSize: "14px",
                    }}
                    onClick={onGestionar(3)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fab fa-cc-visa fw-bold fs-5 mr-2"></i> Tarjeta
                    de Credito
                  </button>
                </div>
                <div className="col-6 mb-2 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    /* disabled={habilitado} */ style={{
                      height: "80px",
                      fontSize: "14px",
                    }}
                    onClick={onGestionar(6)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fas fa-money-check fs-5 mr-2"></i> Deposito
                    Bancario
                  </button>
                </div>
                <div className="col-6 mb-2 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    /* disabled={habilitado} */ style={{
                      height: "80px",
                      fontSize: "14px",
                    }}
                    onClick={onGestionar(5)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fas fa-laptop fs-5 mr-2"></i> Transferencia
                    Bancaria
                  </button>
                </div>
                <div className="col-6 mb-2 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    /* disabled={habilitado} */ style={{
                      height: "80px",
                      fontSize: "14px",
                    }}
                    onClick={onGestionar(4)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fas fa-mobile-alt fs-5 mr-2"></i> Pago Movil
                  </button>
                </div>
                <div className="col-6 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    disabled={props.siescredit !== 1 ? true : false}
                    style={{ height: "80px", fontSize: "14px" }}
                    onClick={onGestionar(8)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fas fa-money-check-alt fs-5 mr-2"></i> Saldo a
                    Credito{" "}
                    {formatMoneda(
                      totalcredito
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </button>
                </div>
                <div className="col-6 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    disabled={props.siesanticipo !== 1 ? true : false}
                    style={{ height: "80px", fontSize: "14px" }}
                    onClick={onGestionar(9)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fas fa-pager fs-5 mr-2"></i> Saldo en Anticipo{" "}
                    {formatMoneda(
                      anticipos.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  </button>
                </div>
                <div className="col-6 d-flex justify-content-center">
                  <button
                    ref={btnAcepta}
                    disabled={props.esretenedor === 1 ? false : true}
                    style={{
                      height: "80px",
                      fontSize: "14px",
                    }}
                    onClick={onGestionar(10)}
                    className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                  >
                    <i className="fas fa-hand-holding-usd fs-5 mr-2"></i> Retenciones
                  </button>
                </div>
              </div>

              <div className="col-md-8 col-sm-12 px-0">
                <div className="col-12 px-0">
                  <TblContainer
                    container={{
                      height: "290px",
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />
                    <TableBody className="overflow-hidden table-bordered">
                      {records &&
                        records.map((item, index) => (
                          <TableRow
                            key={index}
                            style={{ padding: "0", cursor: "pointer" }}
                          >
                            <TableCell className="align-baseline text-center">
                              {item.forma}
                            </TableCell>
                            <TableCell className="align-baseline text-center">
                              {item.referencia}
                            </TableCell>
                            <TableCell className="align-middle text-right">
                              {formatMoneda(
                                item.montos
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="align-baseline text-right">
                              {formatMoneda(
                                item.montoalcambio
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell className="align-baseline text-center">
                              <button
                                className="btn btn-sm mx-1 btn-danger"
                                onClick={eliminarFila(item.index)}
                              >
                                <i className="fa fa-trash"></i>{" "}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                </div>
                <div className="col-12 row m-0 border-azul px-0">
                  <div className="col-md-5 col-sm-4 px-0">
                    <div className="col-pd-280 col-sm-10 col-sm-12 mx-auto mt-2">
                      <div
                        className="col-pd-210 row m-0 py-1 mx-auto d-flex align-items-center"
                        style={{ fontSizeAdjust: "0.5" }}
                      >
                        <span className="col-pd-90 px-1 text-left fs-5 fw-bold">
                          Tasa 1$ ={" "}
                        </span>
                        <span className="col-pd-70 px-0 fw-bold fs-5">
                          &nbsp;
                          {tasa &&
                            formatMoneda(
                              tasa
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                        </span>
                        <span className="col-pd-50 px-0">
                          <button
                            type="button"
                            disabled={props.ope === 0 ? true : false}
                            onClick={() => {
                              /* setCualCat(2); */
                              setMostrar2(true);
                            }}
                            className="btn btn-primary"
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </span>
                      </div>
                      <img src="imagenes/logo.ico" className="img-fluid" />
                    </div>
                  </div>
                  <div
                    className="col-md-7 col-sm-8 ml-auto px-0 row m-0 d-flex align-items-center border-azul py-2"
                    style={{
                      background: "#cfe2ff",
                      borderRadius: "3px",
                      fontSizeAdjust: "0.5",
                    }}
                  >
                    <div
                      className="col-12 row m-0 py-1"
                      style={{ fontSizeAdjust: "0.5" }}
                    >
                      <label className="col-4 px-1 text-left fs-5">
                        Total $:{" "}
                      </label>
                      <span className="col px-0 fw-bold text-right fs-5">
                        &nbsp;
                        {formatMoneda(
                          totaldolares
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </span>
                    </div>

                    <div
                      className="col-12 row m-0 py-1"
                      style={{ fontSizeAdjust: "0.5" }}
                    >
                      <label className="col-4 px-1 text-left fs-5">
                        Total Bs:{" "}
                      </label>
                      <span className="col px-0 fw-bold text-right fs-5">
                        &nbsp;
                        {formatMoneda(
                          totales.toString().replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </span>
                    </div>

                    <div
                      className="col-12 row m-0 py-1"
                      style={{ fontSizeAdjust: "0.5" }}
                    >
                      <label className="col-pd-200 px-1 text-left fs-5">
                        Total Retenciones $:{" "}
                      </label>
                      <span className="col px-0 fw-bold text-right fs-5">
                        &nbsp;
                        {formatMoneda(
                          totalesr.toString().replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </span>
                    </div>

                    <div
                      className="col-12 row m-0 py-1"
                      style={{ fontSizeAdjust: "0.5" }}
                    >
                      <label className="col-pd-200 px-1 text-left fs-5">
                        Total Retenciones Bs:{" "}
                      </label>
                      <span className="col px-0 fw-bold text-right fs-5">
                        &nbsp;
                        {formatMoneda(
                          totalesrb.toString().replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </span>
                    </div>

                    <div
                      className="col-12 row m-0 py-1"
                      style={{ fontSizeAdjust: "0.5" }}
                    >
                      <label className="col-pd-180 px-1 text-left fs-5">
                        {totalsobra > 0 ? "Sobrante $:" : "Restante a Pagar $:"}{" "}
                      </label>
                      <span className="col px-0 fw-bold text-right fs-5">
                        &nbsp;
                        {totalsobra > 0
                          ? formatMoneda(
                            totalsobra
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )
                          : formatMoneda(
                            totalresta
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                      </span>
                    </div>

                    <div
                      className="col-12 px-1 row m-0 py-1"
                      style={{ fontSizeAdjust: "0.5" }}
                    >
                      <label className="col-pd-200 px-2 text-left fs-5">
                        {sobrabs > 0 ? "Sobrante Bs:" : "Restante a Pagar Bs:"}
                      </label>
                      <span className="col px-1 fw-bold text-right fs-5">
                        &nbsp;
                        {sobrabs > 0
                          ? formatMoneda(
                            sobrabs
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )
                          : formatMoneda(
                            restabs
                              .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className="col-md-4 ml-auto px-0 m-0 d-flex justify-content-end">
            <button
              ref={btnAcepta}
              disabled={props.ope === 0 ? true : false}
              onClick={onChangeValidar}
              className="btn btn-sm rounded-pill btn-success mx-1"
            >
              <i className="fas fa-sync-alt">
                {" "}
                Procesar Pago
              </i>
            </button>
            <button
              ref={btnCancela}
              onClick={cancelar}
              className="btn btn-danger btn-sm rounded-pill mx-1"
            >
              <i className="fas fa-window-close">
                {" "}
                Cancelar
              </i>
            </button>
          </div>
        </div>
      </Modal.Footer>

      <ProcesosMontos
        show={mostrar1}
        ope={operacion}
        data={records}
        idclients={props.idclient}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaData={handleAceptaDatos}
      />

      {/*  <TablaRetencionesporCobrar
        show={mostrar3}
        ope={operacion}
        montonota={props.monto}
        montoiva={props.montoiva}
        numfact={props.numfactu}
        idclient={props.idclient}
        ivas={props.iva}
        onHideCancelar={() => setMostrar3(false)}
        onHideAceptaData={handleAceptaDatosReten}
      /> */}

      <CatalogoValorMonedas
        show={mostrar2}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaValorMoneda}
      />

    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/ventas/modalRegistrarPago.js